var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "docs/img"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6",
    width: 20,
    height: 20,
    rx: 4,
    fill: "#C84031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 215",
    d: "M5.87097 12L2 17H18L12.6452 10.5L8.77419 15.5L5.87097 12Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.fec6ac6c00640b31ff42aaf6ce6970cb.svg";
export { ForwardRef as ReactComponent };